import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import locale from './locale/localeSlice'
import establishment from './establishment'
import { barcodeScannerReducer } from 'react-usb-barcode-scanner'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        establishment,
        base,
        locale,
        barcodeScanner: barcodeScannerReducer,
        ...asyncReducers
    })
    return combinedReducer(state, action)
}

export default rootReducer
